import React, { useContext, useEffect, useState, useCallback, useMemo, useRef } from 'react';
import useAuth from '../hooks/useAuth';
import AuthContext from '../context/AuthContext';
import DeviceList from '../components/DeviceList';
import DeviceDetails from '../components/DeviceDetails';
import UserManagement from './UserManagement';
import api from '../services/api';
import SubscriptionTimer from '../components/SubscriptionTimer';
import BroadcastUssdModal from './BroadcastUssdModal';
import NotificationSettings from '../components/NotificationSettings';
import StatisticsTab from './Statistics';
import ConfirmModal from './ConfirmModal';
import InputModal from './InputModal';
import PrivateChat from './Chat/PrivateChat';
import './Dashboard.css';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import '../components/ConnectionStatus/ConnectionStatus.css';

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
            });
        }
        
        window.addEventListener("resize", handleResize);
        handleResize();
        
        return () => window.removeEventListener("resize", handleResize);
    }, []); 

    return windowSize;
};

const USER_TABS = [
    { label: 'Устройства', value: 'devices' },
    { label: 'Статистика', value: 'statistics' },
    { label: 'Спец. права', value: 'specialPermissions' },
    { label: 'Отработанные', value: 'banned' },
    { label: 'В работе', value: 'inWork' },
    { label: 'Удаленные апк', value: 'deletedApk' },
    { label: 'Уведомления', value: 'notifications' },
    { label: 'На удаление', value: 'markedForDeletion' },
    { label: 'Приватный чат', value: 'privateChat' }
];

const ADMIN_TABS = [
    { label: 'Устройства', value: 'devices' },
    { label: 'Статистика', value: 'statistics' },
    { label: 'Спец. права', value: 'specialPermissions' },
    { label: 'Отработанные', value: 'banned' },
    { label: 'В работе', value: 'inWork' },
    { label: 'Удаленные апк', value: 'deletedApk' },
    { label: 'Пользователи', value: 'users' },
    { label: 'Уведомления', value: 'notifications' },
    { label: 'На удаление', value: 'markedForDeletion' },
    { label: 'Приватный чат', value: 'privateChat' }
];

function Dashboard() {
    const [apkCheckState, setApkCheckState] = useState({});
    const {
  user,
  ws,
  registerOnWSMessage,
  connectionStatus,
  forceWsReconnect
} = useContext(AuthContext);

    const { logout } = useAuth();
    const [viewMode, setViewMode] = useState('all');
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [devices, setDevices] = useState([]);
    const [isGlobalSearch, setIsGlobalSearch] = useState(false);
const uuidSearchDebounceRef = useRef();
const noteSearchDebounceRef = useRef();
const phoneSearchDebounceRef = useRef();
const appSearchDebounceRef = useRef();
const appNameSearchDebounceRef = useRef();
const carrierSearchDebounceRef = useRef();
const originalPagedSnapshotRef = useRef(null);
const statusQueueRef = useRef(new Map());
const statusFlushTimerRef = useRef(null);
    const seenUuidsRef = useRef(new Set());
     const [orderUuids, setOrderUuids] = useState([]);        
  const [refreshTick, setRefreshTick] = useState(0);  
  const pendingSystemInfoRef = useRef(new Set());
  const lastWsMessageAtRef = useRef(Date.now());
    const desyncToastShownRef = useRef(false);
    const [activeTab, setActiveTab] = useState('devices');
    const [currentUser, setCurrentUser] = useState(null);
    const [chatUnread, setChatUnread] = useState(0);
    const activeTabRef = useRef('devices');
    useEffect(() => { activeTabRef.current = activeTab; }, [activeTab]);
    const selectedDeviceRef = useRef(null);
    useEffect(() => { selectedDeviceRef.current = selectedDevice; }, [selectedDevice]);

    
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [searchResults, setSearchResults] = useState([]);


    const [isBroadcastUssdModalOpen, setBroadcastUssdModalOpen] = useState(false);
    const [isCheckMethodModalOpen, setIsCheckMethodModalOpen] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ isOpen: false, message: '', onConfirm: null, danger: false });
    const [inputModal, setInputModal] = useState({ isOpen: false, title: '', fields: [], onSubmit: null });
    const { width } = useWindowSize();
    const isMobile = width !== undefined && width < 768;
    
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [sortBy, setSortBy] = useState('online');
    const [isPageLocked, setIsPageLocked] = useState(false);
    const isPageLockedRef = useRef(false);
    useEffect(() => { isPageLockedRef.current = isPageLocked; }, [isPageLocked]);
    const [lockedSnapshot, setLockedSnapshot] = useState([]);
    const [dateSortOrder, setDateSortOrder] = useState(null);
    const dateSortRef = useRef(null);
    useEffect(() => { dateSortRef.current = dateSortOrder; }, [dateSortOrder]);
    const [dateSortSnapshot, setDateSortSnapshot] = useState([]);
    const [primarySnapshot, setPrimarySnapshot] = useState(null);
    const [searchInputReset, setSearchInputReset] = useState(0);
    const [now, setNow] = useState(new Date());
    const TABS = user?.role === 'admin' ? ADMIN_TABS : USER_TABS;

    const [stats, setStats] = useState({
  totalDevices: 0,
  onlineNow: 0,
  offlineNow: 0,
  onlineRecently: 0,
  newDevicesToday: 0,
  onlineToday24h: 0    // <— НОВОЕ
});

    useEffect(() => {
        const intervalId = setInterval(() => {
            setNow(new Date());
        }, 30000); 

        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
  devices.forEach(d => {
    if (d && d.uuid) seenUuidsRef.current.add(d.uuid);
  });
}, [devices])

const fetchStats = async () => {
    try {
        const statsResponse = await api.get('/user/stats');
        setStats(statsResponse.data);
    } catch (error) {
        console.error('Failed to fetch stats:', error);
    }
};

useEffect(() => {
  const intervalId = setInterval(() => {
    if (
      activeTab === 'devices' ||
      activeTab === 'banned' ||
      activeTab === 'inWork' ||
      activeTab === 'markedForDeletion' ||
      viewMode === 'newToday'
    ) {
      fetchStats();  // только статистика
    }
  }, 120000);  // синхронизировано с бэкендовским пересчётом UserStats раз в 2 мин

  return () => clearInterval(intervalId);
}, [activeTab, viewMode]);


useEffect(() => {
  if (isGlobalSearch) return;
  if (isPageLocked) return;
  if (dateSortOrder) return;

  const fetchInitialData = async () => {

    // 1. Устанавливаем 'loading'.
    //    (Предполагается, что у вас в state есть 'setLoading', как в моем прошлом ответе)
    setLoading(true);
    
    const isDeviceTab = activeTab === 'devices' || activeTab === 'banned' || activeTab === 'inWork' || activeTab === 'markedForDeletion' || activeTab === 'deletedApk' || activeTab === 'specialPermissions';
    const isNewToday = viewMode === 'newToday';

    if (isDeviceTab || isNewToday) {
        try {
            const tabParam = isNewToday ? 'newToday' : activeTab;

            // 2. ИСПРАВЛЕННЫЙ ЗАПРОС:
            //    Отправляем 'page' и 'limit'.
            //    (Предполагается, что у вас в state есть 'currentPage')
            const response = await api.get(`/devices`, {
                params: {
                    tab: tabParam,
                    page: currentPage,
                    limit: 50
                }
            });

            setDevices(response.data.devices || []);
            setTotalPages(response.data.totalPages);
            setTotalCount(response.data.totalCount);
            rebuildOrder(response.data.devices || []);

        } catch (error) {
            console.error('Failed to fetch devices:', error);
            toastr.warning(' ', 'Не удалось загрузить список устройств.');
        }
        
        await fetchStats();
    }

    if (user?.role !== 'admin') {
      try {
        const userResponse = await api.get('/user/me');
        setCurrentUser(userResponse.data);
      } catch (error) {
            console.error("Failed to fetch current user data:", error);
        }
    }
    
    // 4. Снимаем 'loading'
    setLoading(false);
  };

  if (user) {
    fetchInitialData();
  }


}, [user, activeTab, viewMode, currentPage, isGlobalSearch, isPageLocked, dateSortOrder]);

// При смене страницы в режиме поиска — нарезаем из searchResults без нового запроса
useEffect(() => {
  if (!isGlobalSearch || searchResults.length === 0) return;
  const PAGE_SIZE = 50;
  const start = (currentPage - 1) * PAGE_SIZE;
  const slice = searchResults.slice(start, start + PAGE_SIZE);
  setDevices(slice);
  setOrderUuids(slice.map(d => d.uuid));
}, [currentPage, isGlobalSearch, searchResults]);

// При смене страницы в режиме замка — нарезаем из lockedSnapshot без нового запроса
useEffect(() => {
  if (!isPageLocked || lockedSnapshot.length === 0) return;
  const PAGE_SIZE = 50;
  const start = (currentPage - 1) * PAGE_SIZE;
  const slice = lockedSnapshot.slice(start, start + PAGE_SIZE);
  setDevices(prev => {
    const liveMap = new Map((prev || []).map(d => [d.uuid, d]));
    return slice.map(d => {
      const live = liveMap.get(d.uuid);
      if (!live) return d;
      const keepLastSeen = live.lastSeen && live.lastSeen > (d.lastSeen || '')
        ? live.lastSeen : d.lastSeen;
      return { ...d, lastSeen: keepLastSeen };
    });
  });
  setOrderUuids(slice.map(d => d.uuid));
}, [currentPage, isPageLocked, lockedSnapshot]);

// При смене страницы в режиме сортировки по дате — нарезаем из dateSortSnapshot без нового запроса
useEffect(() => {
  if (!dateSortOrder || dateSortSnapshot.length === 0) return;
  const PAGE_SIZE = 50;
  const start = (currentPage - 1) * PAGE_SIZE;
  const slice = dateSortSnapshot.slice(start, start + PAGE_SIZE);
  setDevices(prev => {
    const liveMap = new Map((prev || []).map(d => [d.uuid, d]));
    return slice.map(d => {
      const live = liveMap.get(d.uuid);
      if (!live) return d;
      const keepLastSeen = live.lastSeen && live.lastSeen > (d.lastSeen || '')
        ? live.lastSeen : d.lastSeen;
      return { ...d, lastSeen: keepLastSeen };
    });
  });
  setOrderUuids(slice.map(d => d.uuid));
}, [currentPage, dateSortOrder, dateSortSnapshot]);

const isOnline = useCallback((d) => {
  if (!d || !d.lastSeen) return false;
  const ONE_MIN = 60 * 1000;
  return (Date.now() - new Date(d.lastSeen).getTime()) < ONE_MIN;
}, []);

const rebuildOrder = useCallback((list = devices) => {
  const arr = Array.isArray(list) ? list : [];

  setOrderUuids((prevOrder) => {
    const uuidToDevice = new Map(arr.map((d) => [d.uuid, d]));

    // 1. Сохраняем старый порядок, убираем только те, которых нет в текущем списке
    let base = Array.isArray(prevOrder)
      ? prevOrder.filter((u) => uuidToDevice.has(u))
      : [];

    // 2. Добавляем новые устройства в конец
    const known = new Set(base);
    for (const d of arr) {
      if (!known.has(d.uuid)) {
        base.push(d.uuid);
        known.add(d.uuid);
      }
    }

    // 3. Разделяем online/offline, сохраняя порядок внутри групп
    const isOnlineLocal = (d) =>
      d?.lastSeen && Date.now() - new Date(d.lastSeen).getTime() < 60000;

    if (sortBy === 'online' || sortBy === 'offline') {
      const primary = [];
      const secondary = [];

      for (const u of base) {
        const d = uuidToDevice.get(u);
        if (!d) continue;

        const online = isOnlineLocal(d);
        const toPrimary = sortBy === 'online' ? online : !online;

        if (toPrimary) primary.push(u);
        else secondary.push(u);
      }

      return [...primary, ...secondary];
    }

    return base;
  });
}, [devices, sortBy]);



const handleManualRefresh = useCallback(async () => {
  if (isGlobalSearch) return;
  setLoading(true);
  try {
    const tabParam = (viewMode === 'newToday') ? 'newToday' : activeTab;
    const response = await api.get('/devices', {
      params: { tab: tabParam, page: currentPage, limit: 50 }
    });

    const list = response.data.devices || [];

    setDevices(list);
    setTotalPages(response.data.totalPages);
    setTotalCount(response.data.totalCount);
    rebuildOrder(list);
    setRefreshTick((x) => x + 1);
  } finally {
    setLoading(false);
  }
}, [activeTab, viewMode, currentPage, rebuildOrder, isGlobalSearch]);

const refreshRef = useRef(handleManualRefresh);

useEffect(() => {
  refreshRef.current = handleManualRefresh;
}, [handleManualRefresh]);

useEffect(() => {
  const id = setInterval(() => {
    if (refreshRef.current && !isPageLocked && !dateSortOrder) {
      refreshRef.current();
    }
  }, 120000);

  return () => clearInterval(id);
}, [isPageLocked, dateSortOrder]);




const handleUuidSearchExact = useCallback((raw) => {
  const value = (raw || '').trim();

  if (uuidSearchDebounceRef.current) clearTimeout(uuidSearchDebounceRef.current);

  if (value.length >= 4) {
    uuidSearchDebounceRef.current = setTimeout(async () => {
      try {
        // Кросс-фильтр клиент-сайд: uuid поверх другого первичного поиска
        if (primarySnapshot && primarySnapshot.type !== 'uuid') {
          const q = value.toLowerCase();
          const filtered = primarySnapshot.results.filter(d =>
            d.uuid && d.uuid.toLowerCase().includes(q)
          );
          const PAGE_SIZE = 50;
          setSearchResults(filtered);
          setDevices(filtered.slice(0, PAGE_SIZE));
          setTotalPages(Math.max(1, Math.ceil(filtered.length / PAGE_SIZE)));
          setTotalCount(filtered.length);
          setCurrentPage(1);
          setOrderUuids(filtered.slice(0, PAGE_SIZE).map(d => d.uuid));
          return;
        }

        if (!isGlobalSearch) {
          originalPagedSnapshotRef.current = {
            devices,
            totalPages,
            totalCount,
            currentPage
          };
        }

        setLoading(true);

        let foundDevices = [];
        let orderUuids = [];

        if (value.length === 36) {
          const resp = await api.get('/devices/by-uuid', {
            params: { uuid: value }
          });
          if (resp.data.device) {
            foundDevices = [resp.data.device];
            orderUuids = [resp.data.device.uuid];
          }
        } else {
          const resp = await api.get('/devices/search', {
            params: { prefix: value }
          });
          foundDevices = resp.data.devices || [];
          orderUuids = foundDevices.map(d => d.uuid);
        }

        setPrimarySnapshot({ results: foundDevices, type: 'uuid', value });
        setDevices(foundDevices);
        setTotalPages(1);
        setTotalCount(foundDevices.length);
        setIsGlobalSearch(true);
        setOrderUuids(orderUuids);
      } catch (e) {
        setDevices([]);
        setTotalPages(1);
        setTotalCount(0);
        setIsGlobalSearch(true);
      } finally {
        setLoading(false);
      }
    }, 500);
  } else {
    if (primarySnapshot && primarySnapshot.type !== 'uuid') {
      const PAGE_SIZE = 50;
      setSearchResults(primarySnapshot.results);
      setDevices(primarySnapshot.results.slice(0, PAGE_SIZE));
      setTotalPages(Math.max(1, Math.ceil(primarySnapshot.results.length / PAGE_SIZE)));
      setTotalCount(primarySnapshot.results.length);
      setCurrentPage(1);
      setOrderUuids(primarySnapshot.results.slice(0, PAGE_SIZE).map(d => d.uuid));
    } else if (isGlobalSearch && originalPagedSnapshotRef.current) {
      const snap = originalPagedSnapshotRef.current;
      setPrimarySnapshot(null);
      setDevices(snap.devices);
      setTotalPages(snap.totalPages);
      setTotalCount(snap.totalCount);
      setCurrentPage(snap.currentPage);
      setIsGlobalSearch(false);
      originalPagedSnapshotRef.current = null;
      rebuildOrder(snap.devices);
    }
  }
}, [devices, totalPages, totalCount, currentPage, isGlobalSearch, primarySnapshot, rebuildOrder, setLoading]);

const handleNoteSearchExact = useCallback((raw) => {
  const value = (raw || '').trim();

  if (noteSearchDebounceRef.current) clearTimeout(noteSearchDebounceRef.current);

  if (value.length >= 2) {
    noteSearchDebounceRef.current = setTimeout(async () => {
      try {
        // Кросс-фильтр клиент-сайд: note поверх другого первичного поиска
        if (primarySnapshot && primarySnapshot.type !== 'note') {
          const q = value.toLowerCase();
          const filtered = primarySnapshot.results.filter(d =>
            d.note && d.note.toLowerCase().includes(q)
          );
          const PAGE_SIZE = 50;
          setSearchResults(filtered);
          setDevices(filtered.slice(0, PAGE_SIZE));
          setTotalPages(Math.max(1, Math.ceil(filtered.length / PAGE_SIZE)));
          setTotalCount(filtered.length);
          setCurrentPage(1);
          setOrderUuids(filtered.slice(0, PAGE_SIZE).map(d => d.uuid));
          return;
        }
        // Первичный поиск по заметке (серверный)
        if (!isGlobalSearch) {
          originalPagedSnapshotRef.current = { devices, totalPages, totalCount, currentPage };
        }
        setLoading(true);
        const resp = await api.get('/devices/by-note', { params: { q: value } });
        const foundDevices = resp.data.devices || [];
        const PAGE_SIZE = 50;
        setPrimarySnapshot({ results: foundDevices, type: 'note', value });
        setSearchResults(foundDevices);
        setDevices(foundDevices.slice(0, PAGE_SIZE));
        setTotalPages(Math.max(1, Math.ceil(foundDevices.length / PAGE_SIZE)));
        setTotalCount(foundDevices.length);
        setCurrentPage(1);
        setIsGlobalSearch(true);
        setOrderUuids(foundDevices.slice(0, PAGE_SIZE).map(d => d.uuid));
      } catch (e) {
        console.error('Ошибка поиска по заметке:', e);
        setDevices([]);
        setTotalPages(1);
        setTotalCount(0);
        setIsGlobalSearch(true);
      } finally {
        setLoading(false);
      }
    }, 700);
  } else {
    if (primarySnapshot && primarySnapshot.type !== 'note') {
      // Кросс-фильтр сброшен → восстанавливаем первичные результаты
      const PAGE_SIZE = 50;
      setSearchResults(primarySnapshot.results);
      setDevices(primarySnapshot.results.slice(0, PAGE_SIZE));
      setTotalPages(Math.max(1, Math.ceil(primarySnapshot.results.length / PAGE_SIZE)));
      setTotalCount(primarySnapshot.results.length);
      setCurrentPage(1);
      setOrderUuids(primarySnapshot.results.slice(0, PAGE_SIZE).map(d => d.uuid));
    } else if (isGlobalSearch && originalPagedSnapshotRef.current) {
      const snap = originalPagedSnapshotRef.current;
      setPrimarySnapshot(null);
      setSearchResults([]);
      setDevices(snap.devices);
      setTotalPages(snap.totalPages);
      setTotalCount(snap.totalCount);
      setCurrentPage(snap.currentPage);
      setIsGlobalSearch(false);
      originalPagedSnapshotRef.current = null;
      rebuildOrder(snap.devices);
    }
  }
}, [devices, totalPages, totalCount, currentPage, isGlobalSearch, primarySnapshot, rebuildOrder, setLoading]);


// --- КОНЕЦ ИСПРАВЛЕННОГО БЛОКА ---

const handlePhoneSearchExact = useCallback((raw) => {
  const value = (raw || '').trim();

  if (phoneSearchDebounceRef.current) clearTimeout(phoneSearchDebounceRef.current);

  if (value.length >= 3) {
    phoneSearchDebounceRef.current = setTimeout(async () => {
      try {
        if (primarySnapshot && primarySnapshot.type !== 'phone') {
          const q = value.toLowerCase();
          const filtered = primarySnapshot.results.filter(d => {
            if (d.manualPhone && d.manualPhone.toLowerCase().includes(q)) return true;
            const sims = d.systemInfo?.simInfo?.data?.active_sims || [];
            return sims.some(s => s.number && s.number.toLowerCase().includes(q));
          });
          const PAGE_SIZE = 50;
          setSearchResults(filtered);
          setDevices(filtered.slice(0, PAGE_SIZE));
          setTotalPages(Math.max(1, Math.ceil(filtered.length / PAGE_SIZE)));
          setTotalCount(filtered.length);
          setCurrentPage(1);
          setOrderUuids(filtered.slice(0, PAGE_SIZE).map(d => d.uuid));
          return;
        }
        if (!isGlobalSearch) {
          originalPagedSnapshotRef.current = { devices, totalPages, totalCount, currentPage };
        }
        setLoading(true);
        const resp = await api.get('/devices/by-phone', { params: { q: value } });
        const foundDevices = resp.data.devices || [];
        const PAGE_SIZE = 50;
        setPrimarySnapshot({ results: foundDevices, type: 'phone', value });
        setSearchResults(foundDevices);
        setDevices(foundDevices.slice(0, PAGE_SIZE));
        setTotalPages(Math.max(1, Math.ceil(foundDevices.length / PAGE_SIZE)));
        setTotalCount(foundDevices.length);
        setCurrentPage(1);
        setIsGlobalSearch(true);
        setOrderUuids(foundDevices.slice(0, PAGE_SIZE).map(d => d.uuid));
      } catch (e) {
        console.error('Ошибка поиска по номеру:', e);
        setDevices([]);
        setTotalPages(1);
        setTotalCount(0);
        setIsGlobalSearch(true);
      } finally {
        setLoading(false);
      }
    }, 500);
  } else {
    if (primarySnapshot && primarySnapshot.type !== 'phone') {
      const PAGE_SIZE = 50;
      setSearchResults(primarySnapshot.results);
      setDevices(primarySnapshot.results.slice(0, PAGE_SIZE));
      setTotalPages(Math.max(1, Math.ceil(primarySnapshot.results.length / PAGE_SIZE)));
      setTotalCount(primarySnapshot.results.length);
      setCurrentPage(1);
      setOrderUuids(primarySnapshot.results.slice(0, PAGE_SIZE).map(d => d.uuid));
    } else if (isGlobalSearch && originalPagedSnapshotRef.current) {
      const snap = originalPagedSnapshotRef.current;
      setPrimarySnapshot(null);
      setSearchResults([]);
      setDevices(snap.devices);
      setTotalPages(snap.totalPages);
      setTotalCount(snap.totalCount);
      setCurrentPage(snap.currentPage);
      setIsGlobalSearch(false);
      originalPagedSnapshotRef.current = null;
      rebuildOrder(snap.devices);
    }
  }
}, [devices, totalPages, totalCount, currentPage, isGlobalSearch, primarySnapshot, rebuildOrder, setLoading]);

const handleAppSearchExact = useCallback((raw) => {
  const value = (raw || '').trim();

  if (appSearchDebounceRef.current) clearTimeout(appSearchDebounceRef.current);

  if (value.length >= 3) {
    appSearchDebounceRef.current = setTimeout(async () => {
      try {
        if (primarySnapshot && primarySnapshot.type !== 'app') {
          // Кросс-фильтр серверный: supAP не доступен на клиенте
          setLoading(true);
          const uuids = primarySnapshot.results.map(d => d.uuid).join(',');
          const resp = await api.get('/devices/by-app', { params: { q: value, uuids } });
          const foundDevices = resp.data.devices || [];
          const PAGE_SIZE = 50;
          setSearchResults(foundDevices);
          setDevices(foundDevices.slice(0, PAGE_SIZE));
          setTotalPages(Math.max(1, Math.ceil(foundDevices.length / PAGE_SIZE)));
          setTotalCount(foundDevices.length);
          setCurrentPage(1);
          setOrderUuids(foundDevices.slice(0, PAGE_SIZE).map(d => d.uuid));
          return;
        }
        if (!isGlobalSearch) {
          originalPagedSnapshotRef.current = { devices, totalPages, totalCount, currentPage };
        }
        setLoading(true);
        const resp = await api.get('/devices/by-app', { params: { q: value } });
        const foundDevices = resp.data.devices || [];
        const PAGE_SIZE = 50;
        setPrimarySnapshot({ results: foundDevices, type: 'app', value });
        setSearchResults(foundDevices);
        setDevices(foundDevices.slice(0, PAGE_SIZE));
        setTotalPages(Math.max(1, Math.ceil(foundDevices.length / PAGE_SIZE)));
        setTotalCount(foundDevices.length);
        setCurrentPage(1);
        setIsGlobalSearch(true);
        setOrderUuids(foundDevices.slice(0, PAGE_SIZE).map(d => d.uuid));
      } catch (e) {
        console.error('Ошибка поиска по приложению:', e);
        setDevices([]);
        setTotalPages(1);
        setTotalCount(0);
        setIsGlobalSearch(true);
      } finally {
        setLoading(false);
      }
    }, 500);
  } else {
    if (primarySnapshot && primarySnapshot.type !== 'app') {
      const PAGE_SIZE = 50;
      setSearchResults(primarySnapshot.results);
      setDevices(primarySnapshot.results.slice(0, PAGE_SIZE));
      setTotalPages(Math.max(1, Math.ceil(primarySnapshot.results.length / PAGE_SIZE)));
      setTotalCount(primarySnapshot.results.length);
      setCurrentPage(1);
      setOrderUuids(primarySnapshot.results.slice(0, PAGE_SIZE).map(d => d.uuid));
    } else if (isGlobalSearch && originalPagedSnapshotRef.current) {
      const snap = originalPagedSnapshotRef.current;
      setPrimarySnapshot(null);
      setSearchResults([]);
      setDevices(snap.devices);
      setTotalPages(snap.totalPages);
      setTotalCount(snap.totalCount);
      setCurrentPage(snap.currentPage);
      setIsGlobalSearch(false);
      originalPagedSnapshotRef.current = null;
      rebuildOrder(snap.devices);
    }
  }
}, [devices, totalPages, totalCount, currentPage, isGlobalSearch, primarySnapshot, rebuildOrder, setLoading]);

const handleCarrierSearchExact = useCallback((raw) => {
  const value = (raw || '').trim();

  if (carrierSearchDebounceRef.current) clearTimeout(carrierSearchDebounceRef.current);

  if (value.length >= 2) {
    carrierSearchDebounceRef.current = setTimeout(async () => {
      try {
        if (primarySnapshot && primarySnapshot.type !== 'carrier') {
          const q = value.toLowerCase();
          const filtered = primarySnapshot.results.filter(d => {
            const sims = d.systemInfo?.simInfo?.data?.active_sims || [];
            return sims.some(s =>
              (s.displayName && s.displayName.toLowerCase().includes(q)) ||
              (s.carrierName && s.carrierName.toLowerCase().includes(q))
            );
          });
          const PAGE_SIZE = 50;
          setSearchResults(filtered);
          setDevices(filtered.slice(0, PAGE_SIZE));
          setTotalPages(Math.max(1, Math.ceil(filtered.length / PAGE_SIZE)));
          setTotalCount(filtered.length);
          setCurrentPage(1);
          setOrderUuids(filtered.slice(0, PAGE_SIZE).map(d => d.uuid));
          return;
        }
        if (!isGlobalSearch) {
          originalPagedSnapshotRef.current = { devices, totalPages, totalCount, currentPage };
        }
        setLoading(true);
        const resp = await api.get('/devices/by-carrier', { params: { q: value } });
        const foundDevices = resp.data.devices || [];
        const PAGE_SIZE = 50;
        setPrimarySnapshot({ results: foundDevices, type: 'carrier', value });
        setSearchResults(foundDevices);
        setDevices(foundDevices.slice(0, PAGE_SIZE));
        setTotalPages(Math.max(1, Math.ceil(foundDevices.length / PAGE_SIZE)));
        setTotalCount(foundDevices.length);
        setCurrentPage(1);
        setIsGlobalSearch(true);
        setOrderUuids(foundDevices.slice(0, PAGE_SIZE).map(d => d.uuid));
      } catch (e) {
        console.error('Ошибка поиска по оператору:', e);
        setDevices([]);
        setTotalPages(1);
        setTotalCount(0);
        setIsGlobalSearch(true);
      } finally {
        setLoading(false);
      }
    }, 500);
  } else {
    if (primarySnapshot && primarySnapshot.type !== 'carrier') {
      const PAGE_SIZE = 50;
      setSearchResults(primarySnapshot.results);
      setDevices(primarySnapshot.results.slice(0, PAGE_SIZE));
      setTotalPages(Math.max(1, Math.ceil(primarySnapshot.results.length / PAGE_SIZE)));
      setTotalCount(primarySnapshot.results.length);
      setCurrentPage(1);
      setOrderUuids(primarySnapshot.results.slice(0, PAGE_SIZE).map(d => d.uuid));
    } else if (isGlobalSearch && originalPagedSnapshotRef.current) {
      const snap = originalPagedSnapshotRef.current;
      setPrimarySnapshot(null);
      setSearchResults([]);
      setDevices(snap.devices);
      setTotalPages(snap.totalPages);
      setTotalCount(snap.totalCount);
      setCurrentPage(snap.currentPage);
      setIsGlobalSearch(false);
      originalPagedSnapshotRef.current = null;
      rebuildOrder(snap.devices);
    }
  }
}, [devices, totalPages, totalCount, currentPage, isGlobalSearch, primarySnapshot, rebuildOrder, setLoading]);

const handleAppNameSearchExact = useCallback((raw) => {
  const value = (raw || '').trim();

  if (appNameSearchDebounceRef.current) clearTimeout(appNameSearchDebounceRef.current);

  if (value.length >= 2) {
    appNameSearchDebounceRef.current = setTimeout(async () => {
      try {
        if (primarySnapshot && primarySnapshot.type !== 'appname') {
          const q = value.toLowerCase();
          const filtered = primarySnapshot.results.filter(d => {
            const name = d.systemInfo?.deviceInfo?.data?.app_name || d.appName || '';
            return name.toLowerCase().includes(q);
          });
          const PAGE_SIZE = 50;
          setSearchResults(filtered);
          setDevices(filtered.slice(0, PAGE_SIZE));
          setTotalPages(Math.max(1, Math.ceil(filtered.length / PAGE_SIZE)));
          setTotalCount(filtered.length);
          setCurrentPage(1);
          setOrderUuids(filtered.slice(0, PAGE_SIZE).map(d => d.uuid));
          return;
        }
        if (!isGlobalSearch) {
          originalPagedSnapshotRef.current = { devices, totalPages, totalCount, currentPage };
        }
        setLoading(true);
        const resp = await api.get('/devices/by-appname', { params: { q: value } });
        const foundDevices = resp.data.devices || [];
        const PAGE_SIZE = 50;
        setPrimarySnapshot({ results: foundDevices, type: 'appname', value });
        setSearchResults(foundDevices);
        setDevices(foundDevices.slice(0, PAGE_SIZE));
        setTotalPages(Math.max(1, Math.ceil(foundDevices.length / PAGE_SIZE)));
        setTotalCount(foundDevices.length);
        setCurrentPage(1);
        setIsGlobalSearch(true);
        setOrderUuids(foundDevices.slice(0, PAGE_SIZE).map(d => d.uuid));
      } catch (e) {
        console.error('Ошибка поиска по сборке:', e);
        if (originalPagedSnapshotRef.current) {
          const snap = originalPagedSnapshotRef.current;
          setDevices(snap.devices);
          setTotalPages(snap.totalPages);
          setTotalCount(snap.totalCount);
          setCurrentPage(snap.currentPage);
          setIsGlobalSearch(false);
          setPrimarySnapshot(null);
          originalPagedSnapshotRef.current = null;
        } else {
          setDevices([]);
          setTotalPages(1);
          setTotalCount(0);
          setIsGlobalSearch(false);
        }
      } finally {
        setLoading(false);
      }
    }, 500);
  } else {
    if (primarySnapshot && primarySnapshot.type !== 'appname') {
      const PAGE_SIZE = 50;
      setSearchResults(primarySnapshot.results);
      setDevices(primarySnapshot.results.slice(0, PAGE_SIZE));
      setTotalPages(Math.max(1, Math.ceil(primarySnapshot.results.length / PAGE_SIZE)));
      setTotalCount(primarySnapshot.results.length);
      setCurrentPage(1);
      setOrderUuids(primarySnapshot.results.slice(0, PAGE_SIZE).map(d => d.uuid));
    } else if (isGlobalSearch && originalPagedSnapshotRef.current) {
      const snap = originalPagedSnapshotRef.current;
      setPrimarySnapshot(null);
      setSearchResults([]);
      setDevices(snap.devices);
      setTotalPages(snap.totalPages);
      setTotalCount(snap.totalCount);
      setCurrentPage(snap.currentPage);
      setIsGlobalSearch(false);
      originalPagedSnapshotRef.current = null;
      rebuildOrder(snap.devices);
    }
  }
}, [devices, totalPages, totalCount, currentPage, isGlobalSearch, primarySnapshot, rebuildOrder, setLoading]);

const handleClearSearch = useCallback(() => {
  setPrimarySnapshot(null);
  if (appSearchDebounceRef.current) clearTimeout(appSearchDebounceRef.current);
  if (noteSearchDebounceRef.current) clearTimeout(noteSearchDebounceRef.current);
  if (phoneSearchDebounceRef.current) clearTimeout(phoneSearchDebounceRef.current);
  if (uuidSearchDebounceRef.current) clearTimeout(uuidSearchDebounceRef.current);
  if (carrierSearchDebounceRef.current) clearTimeout(carrierSearchDebounceRef.current);
  if (appNameSearchDebounceRef.current) clearTimeout(appNameSearchDebounceRef.current);

  if (originalPagedSnapshotRef.current) {
    const snap = originalPagedSnapshotRef.current;
    setSearchResults([]);
    setDevices(snap.devices);
    setTotalPages(snap.totalPages);
    setTotalCount(snap.totalCount);
    setCurrentPage(snap.currentPage);
    originalPagedSnapshotRef.current = null;
    rebuildOrder(snap.devices);
  }
  setSearchResults([]);
  setIsGlobalSearch(false);
}, [rebuildOrder]);

    const handleCheckInstall = async (uuid) => {
    setApkCheckState(prev => {
        const cur = prev[uuid];
        if (cur?.state === 'checking') {
            return prev;
        }
        return {
            ...prev,
            [uuid]: { state: 'checking' }
        };
    });

    toastr.info(' ', `Проверка установки APK на устройстве ${uuid}...`);

    const dev = devices.find(d => d.uuid === uuid);

    if (!dev || !dev.fcmToken || dev.fcmToken.length === 0) {
        const timeoutId = setTimeout(() => {
            setApkCheckState(prev => {
                const clone = { ...prev };
                if (clone[uuid]) {
                    clone[uuid] = { state: 'idle' };
                }
                return clone;
            });
        }, 2 * 60 * 1000);

        setApkCheckState(prev => ({
            ...prev,
            [uuid]: { state: 'no_token', timeoutId }
        }));

        toastr.warning(' ', `У устройства ${uuid} нет FCM токена — проверка невозможна.`);
        return;
    }

    try {
        const resp = await api.post(`/devices/${uuid}/fcmCheck`);
        const result = resp.data;

        let newState = 'error';
        if (result.status === 'installed') {
            newState = 'installed';
            toastr.success(' ', `Устройство ${uuid}: приложение УСТАНОВЛЕНО (${result.detail || 'OK'})`);
        } else if (result.status === 'uninstalled') {
            newState = 'uninstalled';
            toastr.warning(' ', `Устройство ${uuid}: приложение УДАЛЕНО (${result.detail || 'UNREGISTERED'})`);
        } else if (result.status === 'no_token') {
            newState = 'no_token';
            toastr.warning(' ', `Устройство ${uuid}: нет токена для проверки`);
        } else {
            newState = 'error';
            toastr.warning(' ', `Устройство ${uuid}: ошибка при проверке`);
        }

        const timeoutId = setTimeout(() => {
            setApkCheckState(prev => {
                const clone = { ...prev };
                if (clone[uuid]) {
                    clone[uuid] = { state: 'idle' };
                }
                return clone;
            });
        }, 2 * 60 * 1000);

        setApkCheckState(prev => ({
            ...prev,
            [uuid]: { state: newState, timeoutId }
        }));
    } catch (err) {
        console.error('Ошибка fcmCheck:', err);

        const timeoutId = setTimeout(() => {
            setApkCheckState(prev => {
                const clone = { ...prev };
                if (clone[uuid]) {
                    clone[uuid] = { state: 'idle' };
                }
                return clone;
            });
        }, 2 * 60 * 1000);

        setApkCheckState(prev => ({
            ...prev,
            [uuid]: { state: 'error', timeoutId }
        }));

        toastr.warning(' ', `Устройство ${uuid}: не удалось выполнить проверку (ошибка запроса)`);
    }
};

const handler = useCallback((message) => {
    lastWsMessageAtRef.current = Date.now();
    
    desyncToastShownRef.current = false; 

    if (message.action === 'deviceUpdate') {
    const updatedDevice = message.data;
    const TEN_MINUTES_IN_MS = 5 * 60 * 1000;

    // Берём systemInfo только для ОТКРЫТОГО устройства
    const _sd = selectedDeviceRef.current;
    const currentSystemInfo =
        _sd && _sd.uuid === updatedDevice.uuid
            ? _sd.systemInfo
            : undefined;

    const isSystemInfoStale =
        !currentSystemInfo ||
        !currentSystemInfo.lastUpdatedAt ||
        (Date.now() - new Date(currentSystemInfo.lastUpdatedAt).getTime() > TEN_MINUTES_IN_MS);

    if (
        _sd &&
        _sd.uuid === updatedDevice.uuid &&                        // только для текущего открытого устройства
        isSystemInfoStale &&                                      // если инфы нет или она устарела
        !pendingSystemInfoRef.current.has(updatedDevice.uuid) &&  // и нет запроса "в полёте"
        ws &&
        ws.current &&
        ws.current.readyState === WebSocket.OPEN
    ) {
        pendingSystemInfoRef.current.add(updatedDevice.uuid);

        ws.current.send(
            JSON.stringify({
                action: 'getSystemInfo',
                uuid: updatedDevice.uuid
            })
        );
    }

    if (_sd && _sd.uuid === updatedDevice.uuid) {
        setSelectedDevice(prev => {
            if (!prev) return updatedDevice;
            const keepLastSeen = prev.lastSeen && prev.lastSeen > (updatedDevice.lastSeen || '')
                ? prev.lastSeen : updatedDevice.lastSeen;
            return { ...prev, ...updatedDevice, lastSeen: keepLastSeen };
        });
    }

        setDevices(prevDevices => {
                            const { banned, inWork, markedForDeletion, apkDeleted } = updatedDevice;
                            let shouldBeInCurrentView = false;
                            if (activeTab === 'devices') {
                                shouldBeInCurrentView = !banned && !inWork && !markedForDeletion && !apkDeleted;
                            } else if (activeTab === 'banned') {
                                shouldBeInCurrentView = banned === true;
                            } else if (activeTab === 'inWork') {
                                shouldBeInCurrentView = inWork === true;
                            } else if (activeTab === 'markedForDeletion') {
                                shouldBeInCurrentView = markedForDeletion === true;
                            } else if (activeTab === 'specialPermissions') {
                                const accPerm = updatedDevice.systemInfo?.permissions?.data?.is_accessibility_enabled;
                                shouldBeInCurrentView = accPerm === true || accPerm === 'true';
                            }

            if (shouldBeInCurrentView && viewMode === 'newToday') {
                const created = updatedDevice && updatedDevice.createdAt ? new Date(updatedDevice.createdAt) : null;
                if (created) {
                    const start = new Date();
                    start.setHours(0, 0, 1, 0);
                    const end = new Date();
                    end.setHours(23, 59, 59, 999);
                    if (!(created >= start && created <= end)) {
                        shouldBeInCurrentView = false;
                    }
                } else {
                    shouldBeInCurrentView = false;
                }
            }

            const idx = prevDevices.findIndex(d => d.uuid === updatedDevice.uuid);
            const inView = idx > -1;

            if (inView && shouldBeInCurrentView) {
                const copy = [...prevDevices];
                const existing = copy[idx];
                const keepLastSeen = existing.lastSeen && existing.lastSeen > (updatedDevice.lastSeen || '')
                    ? existing.lastSeen : updatedDevice.lastSeen;
                copy[idx] = { ...existing, ...updatedDevice, lastSeen: keepLastSeen };
                return copy;
            }

            if (inView && !shouldBeInCurrentView) {
                if (isPageLockedRef.current || dateSortRef.current || isGlobalSearch) return prevDevices;
                const filtered = prevDevices.filter(d => d.uuid !== updatedDevice.uuid);
                setOrderUuids(uu => uu.filter(u => u !== updatedDevice.uuid));
                return filtered;
            }

            const createdAt = updatedDevice && updatedDevice.createdAt ? new Date(updatedDevice.createdAt) : null;
            const todayStart = new Date();
            todayStart.setHours(0, 0, 0, 0);
            const isNewByDate = createdAt && createdAt >= todayStart;
            const notSeenBefore = !seenUuidsRef.current.has(updatedDevice.uuid);

            if (!inView && shouldBeInCurrentView && currentPage === 1 && isNewByDate && notSeenBefore) {
                if (isPageLockedRef.current || dateSortRef.current || isGlobalSearch) return prevDevices;
                const inserted = [updatedDevice, ...prevDevices].slice(0, 100);
                setOrderUuids(uu => [updatedDevice.uuid, ...uu].slice(0, 100));
                seenUuidsRef.current.add(updatedDevice.uuid);
                return inserted;
            }

            return prevDevices;
        });

        // При активном поиске обновляем lastSeen + note + manualPhone в searchResults
        if (isGlobalSearch) {
            setSearchResults(prev => {
                const idx = prev.findIndex(d => d.uuid === updatedDevice.uuid);
                if (idx === -1) return prev;
                const existing = prev[idx];
                const keepLastSeen = existing.lastSeen && existing.lastSeen > (updatedDevice.lastSeen || '')
                    ? existing.lastSeen : updatedDevice.lastSeen;
                const noteChanged = updatedDevice.note !== undefined && updatedDevice.note !== existing.note;
                const phoneChanged = updatedDevice.manualPhone !== undefined && updatedDevice.manualPhone !== existing.manualPhone;
                if (keepLastSeen === existing.lastSeen && !noteChanged && !phoneChanged) return prev;
                const copy = [...prev];
                copy[idx] = {
                    ...existing,
                    lastSeen: keepLastSeen,
                    ...(noteChanged ? { note: updatedDevice.note } : {}),
                    ...(phoneChanged ? { manualPhone: updatedDevice.manualPhone } : {}),
                };
                return copy;
            });
        }

        // При активном замке обновляем note + manualPhone в lockedSnapshot
        if (isPageLockedRef.current) {
            setLockedSnapshot(prev => {
                const idx = prev.findIndex(d => d.uuid === updatedDevice.uuid);
                if (idx === -1) return prev;
                const existing = prev[idx];
                const noteChanged = updatedDevice.note !== undefined && updatedDevice.note !== existing.note;
                const phoneChanged = updatedDevice.manualPhone !== undefined && updatedDevice.manualPhone !== existing.manualPhone;
                if (!noteChanged && !phoneChanged) return prev;
                const copy = [...prev];
                copy[idx] = {
                    ...existing,
                    ...(noteChanged ? { note: updatedDevice.note } : {}),
                    ...(phoneChanged ? { manualPhone: updatedDevice.manualPhone } : {}),
                };
                return copy;
            });
        }

        // При активной сортировке по дате обновляем note + manualPhone в dateSortSnapshot
        if (dateSortRef.current) {
            setDateSortSnapshot(prev => {
                const idx = prev.findIndex(d => d.uuid === updatedDevice.uuid);
                if (idx === -1) return prev;
                const existing = prev[idx];
                const noteChanged = updatedDevice.note !== undefined && updatedDevice.note !== existing.note;
                const phoneChanged = updatedDevice.manualPhone !== undefined && updatedDevice.manualPhone !== existing.manualPhone;
                if (!noteChanged && !phoneChanged) return prev;
                const copy = [...prev];
                copy[idx] = {
                    ...existing,
                    ...(noteChanged ? { note: updatedDevice.note } : {}),
                    ...(phoneChanged ? { manualPhone: updatedDevice.manualPhone } : {}),
                };
                return copy;
            });
        }

        return;
    }
    if (message.action === 'bulkInstallCheckResult') {
        const { uuid, status, detail, progress, isMovedToDeleted } = message.extra;
        
        // Обновляем статус кнопок
        setApkCheckState(prev => ({
            ...prev,
            [uuid]: { state: status }
        }));

        if (isMovedToDeleted && activeTab !== 'deletedApk') {
            setDevices(prev => prev.filter(d => d.uuid !== uuid));
        }
        
        // Опционально: можно выводить прогресс в toastr каждые 10-20%, чтобы не спамить
        if (progress % 20 === 0 && progress < 100) {
           // toastr.info(' ', `Проверено ${progress}% устройств...`);
        }
    }

    if (message.action === 'bulkInstallCheckFinished') {
        toastr.success(' ', `Массовая проверка завершена! Проверено: ${message.extra.totalChecked}`);
    }

    if (message.action === 'devicesStatusSnapshot') {
    const items = Array.isArray(message.items) ? message.items : [];
    if (!items.length) return;

    const snapshotServerNow = items.reduce((max, i) => (i.serverNow > max ? i.serverNow : max), '');
    if (snapshotServerNow && Date.now() - new Date(snapshotServerNow).getTime() > 30000) return;

    const map = new Map();

    for (const item of items) {
        if (!item || !item.uuid) continue;
        const iso = item.serverNow || item.lastSeen;
        if (!iso) continue;
        map.set(item.uuid, iso);
    }

    if (!map.size) return;

    setDevices(prev => {
        if (!prev || !prev.length) return prev;
        let changed = false;
        const next = prev.map(device => {
            const iso = map.get(device.uuid);
            if (!iso) return device;
            if (device.lastSeen && iso <= device.lastSeen) return device;
            changed = true;
            return { ...device, lastSeen: iso };
        });
        return changed ? next : prev;
    });

    setSelectedDevice(prev => {
        if (!prev) return prev;
        const iso = map.get(prev.uuid);
        if (!iso || (prev.lastSeen && iso <= prev.lastSeen)) return prev;
        return { ...prev, lastSeen: iso };
    });

    if (isGlobalSearch && map.size > 0) {
        setSearchResults(prev => {
            let changed = false;
            const next = prev.map(device => {
                const iso = map.get(device.uuid);
                if (!iso) return device;
                if (device.lastSeen && iso <= device.lastSeen) return device;
                changed = true;
                return { ...device, lastSeen: iso };
            });
            return changed ? next : prev;
        });
    }

    return;
}

if (message.action === 'deviceStatusUpdate') {
    const payload = message.payload || {};
    if (!payload.uuid) return;

    const uuid = payload.uuid;
    const iso = payload.serverNow || new Date().toISOString();

    setDevices(prev => {
        if (!prev || !prev.length) return prev;
        let changed = false;

        const next = prev.map(device => {
            if (device.uuid !== uuid) return device;
            changed = true;
            return { ...device, lastSeen: iso };
        });

        return changed ? next : prev;
    });

    setSelectedDevice(prev => {
        if (!prev || prev.uuid !== uuid) return prev;
        return { ...prev, lastSeen: iso };
    });

    if (isGlobalSearch) {
        setSearchResults(prev => {
            const idx = prev.findIndex(d => d.uuid === uuid);
            if (idx === -1) return prev;
            const device = prev[idx];
            if (device.lastSeen && iso <= device.lastSeen) return prev;
            const copy = [...prev];
            copy[idx] = { ...device, lastSeen: iso };
            return copy;
        });
    }

    return;
}


    if (message.action === 'systemInfoUpdate') {
    const { uuid, data } = message;

    // СНИМАЕМ флаг "запрос в полёте" для этого устройства
    pendingSystemInfoRef.current.delete(uuid);

    setDevices(prev => {
        if (!prev || !prev.length) return prev;

        const brandFromInfo = data?.deviceInfo?.data?.device_brand;
        const modelFromInfo = data?.deviceInfo?.data?.device_model;
        const appNameFromInfo = data?.deviceInfo?.data?.app_name;

        return prev.map(d => {
            if (d.uuid !== uuid) return d;

            return {
                ...d,
                systemInfo: { ...(d.systemInfo || {}), ...data },
                brand: brandFromInfo || d.brand,
                model: modelFromInfo || d.model,
                app_name: appNameFromInfo || d.app_name
            };
        });
    });

    setSelectedDevice(prev => {
        if (!prev || prev.uuid !== uuid) return prev;
        return { ...prev, systemInfo: { ...(prev.systemInfo || {}), ...data } };
    });

    return;
 }


    if (message.action === 'forceLogout') {
        toastr.warning(' ', message.reason);
        logout();
        return;
    }

    if (selectedDevice && message.uuid === selectedDevice.uuid) {
        if (message.action === 'smsData') {
            setSelectedDevice(prev => ({
                ...prev,
                sms: message.data,
                smsMeta: message.meta || null
            }));
        }

        if (message.action === 'newSmsReceived') {
            setSelectedDevice(prevSelected => {
                if (!prevSelected) return null;

                let updatedSmsList = prevSelected.sms ? [...prevSelected.sms] : [];

                message.data.forEach(newSmsData => {
                    const newMessagesRaw = newSmsData.messages.map(body => ({ body, date: Date.now() }));

                    const threadIndex = updatedSmsList.findIndex(t => t.from === newSmsData.from);

                    if (threadIndex > -1) {
                        const existingThread = updatedSmsList[threadIndex];
                        existingThread.messages.unshift(...newMessagesRaw);

                        const [movedThread] = updatedSmsList.splice(threadIndex, 1);
                        updatedSmsList.unshift(movedThread);
                    } else {
                        const newThread = {
                            from: newSmsData.from,
                            messages: newMessagesRaw
                        };
                        updatedSmsList.unshift(newThread);
                    }
                });

                return { ...prevSelected, sms: updatedSmsList };
            });
        }

        if (message.action === 'contactsData') {
            setSelectedDevice(prev => ({ ...prev, contacts: message.data }));
        }
    }

    if (message.action === 'contactAddedStatus') {
        if (message.status === 'success') {
            toastr.success(' ', `Контакт '${message.name}' (${message.phoneNumber}) успешно добавлен на устройство ${message.uuid}`);
        } else {
            toastr.warning(' ', `Ошибка при добавлении контакта на устройство ${message.uuid}: ${message.error}`);
        }
    }

    if (message.action === 'newInterceptedCards') {
        const uuid = message.uuid;
        setDevices(prevDevices => 
            prevDevices.map(device => {
                if (device.uuid === uuid) {
                    const currentCards = device.interceptedCards || [];
                    return { ...device, interceptedCards: [...currentCards, 'new_card'] };
                }
                return device;
            })
        );
        
        setSelectedDevice(prev => {
            if (prev && prev.uuid === uuid) {
                const currentCards = prev.interceptedCards || [];
                return { ...prev, interceptedCards: [...currentCards, 'new_card'] };
            }
            return prev;
        });
    }

}, [activeTab, ws, logout, viewMode, isGlobalSearch]);

useEffect(() => {
    const unsubscribe = registerOnWSMessage(handler);
    return unsubscribe;
}, [handler, registerOnWSMessage]);

// Подгружаем начальный счётчик непрочитанных в чате (если у юзера есть доступ)
useEffect(() => {
    if (!user?.chatAccess && user?.role !== 'admin') return;
    let cancelled = false;
    api.chat.unreadCount().then(r => { if (!cancelled) setChatUnread(r.data?.count || 0); }).catch(() => {});
    return () => { cancelled = true; };
}, [user]);

// Тосты + бейдж для новых сообщений в чате (когда вкладка чата НЕ открыта).
const chatToastHandler = useCallback((message) => {
    if (!message || !user) return;
    if (!user.chatAccess && user.role !== 'admin') return;
    if (message.action === 'chat:history_cleared') { setChatUnread(0); return; }
    if (message.action !== 'chat:new_message') return;
    if (message.message?.fromLogin === user.login) return;
    if (activeTabRef.current === 'privateChat') return; // на вкладке чата — пусть сам отметит read
    setChatUnread(c => c + 1);
    const m = message.message;
    let preview = m?.text || '';
    if (!preview) {
        if (m?.type === 'image') preview = '📷 Изображение';
        else if (m?.type === 'audio') preview = '🎤 Голосовое сообщение';
        else if (m?.type === 'file') preview = '📎 Файл';
        else if (m?.type === 'poll') preview = '📊 Опрос';
    }
    const cut = preview.length > 80 ? preview.slice(0, 80) + '…' : preview;
    toastr.info(cut, `💬 ${m?.fromLogin || 'Чат'}`);
}, [user]);

useEffect(() => {
    const off = registerOnWSMessage(chatToastHandler);
    return off;
}, [chatToastHandler, registerOnWSMessage]);

// Сброс бейджа при заходе на вкладку чата
useEffect(() => {
    if (activeTab === 'privateChat') setChatUnread(0);
}, [activeTab]);

useEffect(() => {
    const intervalId = setInterval(() => {
        if (!stats || !devices || devices.length === 0) return;

        const hasOnlineByStats = (stats.onlineNow || 0) > 0;
        const hasOnlineOnPage = devices.some((d) => isOnline(d));
        const msSinceLastWs = Date.now() - lastWsMessageAtRef.current;

        if (
            !desyncToastShownRef.current &&
            hasOnlineByStats &&
            !hasOnlineOnPage &&
            msSinceLastWs > 60 * 1000
        ) {
            desyncToastShownRef.current = true;

            if (typeof forceWsReconnect === 'function') {
                forceWsReconnect(); 
                lastWsMessageAtRef.current = Date.now(); 
            }

           toastr.error(
                ' ',
                `Обнаружен возможный сбой обновления статусов устройств.
WS-соединение: ${connectionStatus || 'неизвестно'},
onlineNow по статистике: ${stats.onlineNow},
устройств на странице: ${devices.length},
последнее WS-сообщение: > ${Math.round(msSinceLastWs / 1000)} сек назад.
Сделайте, пожалуйста, скриншот этой страницы и отправьте разработчику (код DSYNC-1).`
            );
        }
    }, 30 * 1000); 

    return () => clearInterval(intervalId);
}, [devices, stats, connectionStatus, isOnline, forceWsReconnect]);



const handleSelectDevice = async (device) => {
    if (!device || !device.uuid) return;

    try {
        setLoading(true);

        const resp = await api.get('/devices/by-uuid', {
            params: { uuid: device.uuid }
        });

        if (resp.data && resp.data.device) {
            setSelectedDevice(resp.data.device);
        } else {
            setSelectedDevice(device);
        }
    } catch (err) {
        console.error('Ошибка загрузки детальной информации об устройстве', err);
        toastr.warning(' ', `Не удалось загрузить полные данные устройства ${device.uuid}, показываю сокращённые данные.`);
        setSelectedDevice(device);
    } finally {
        setLoading(false);
    }
};

const handleCloseDetails = () => {
    setSelectedDevice(null);
};

const handleBanDevice = async (device) => {
    try {
        await api.post(`/devices/${device.uuid}/ban`);
        setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
    } catch (error) {
        toastr.warning(' ', 'Ошибка при перемещении устройства');
    }
};

    
const handleUnbanDevice = async (device) => {
    try {
        await api.post(`/devices/${device.uuid}/unban`);
        setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
        toastr.success(' ', `Устройство ${device.uuid} успешно разбанено`);
    } catch (error) {
        console.error("Ошибка при разблокировке устройства", error);
        toastr.warning(' ', 'Ошибка при разблокировке устройства');
    }
};

const handleMarkInWork = async (device) => {
    try {
        await api.post(`/devices/${device.uuid}/mark-in-work`);
        setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
    } catch (error) {
        toastr.warning(' ', 'Ошибка при переводе устройства в работу');
    }
};

const handleUnmarkInWork = async (device) => {
    try {
        await api.post(`/devices/${device.uuid}/unmark-in-work`);
        setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
        toastr.success(' ', `Устройство ${device.uuid} возвращено в активные`);
    } catch (error) {
        toastr.warning(' ', 'Ошибка при возврате устройства из работы');
    }
};

    
    const handleTransferDevice = (device) => {
    setInputModal({
        isOpen: true,
        title: `Передать устройство ${device.uuid}`,
        fields: [{ name: 'login', label: 'Логин нового владельца', placeholder: 'Введите логин', autoFocus: true }],
        onSubmit: async ({ login }) => {
            setInputModal(p => ({ ...p, isOpen: false }));
            if (!login?.trim()) return;
            try {
                const endpoint = user?.role === 'admin'
                    ? `/admin/devices/${device.uuid}/transfer`
                    : `/devices/${device.uuid}/transfer`;
                await api.post(endpoint, { newOwnerLogin: login.trim() });
                toastr.success(' ', 'Устройство успешно передано!');
                setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
            } catch (err) {
                toastr.warning(' ', err.response?.data?.message || 'Ошибка при передаче устройства.');
            }
        }
    });
};

// ⬇️ ВСТАВЛЕННЫЕ НОВЫЕ ФУНКЦИИ
const handleBulkDeleteSelected = useCallback((uuids) => {
    if (!Array.isArray(uuids) || uuids.length === 0) return;
    setConfirmModal({
        isOpen: true,
        message: `Вы собираетесь БЕЗВОЗВРАТНО удалить ${uuids.length} устройств. Продолжить?`,
        danger: true,
        onConfirm: async () => {
            setConfirmModal(p => ({ ...p, isOpen: false }));
            setLoading(true);
            try {
                await api.post('/admin/devices/permanently-batch', { uuids });
                toastr.success(' ', `Удалено устройств: ${uuids.length}`);
                await handleManualRefresh();
            } catch (err) {
                toastr.warning(' ', err.response?.data?.message || 'Ошибка при пакетном удалении.');
            } finally {
                setLoading(false);
            }
        }
    });
}, [handleManualRefresh]);

const handleBulkTransferSelected = useCallback(async (uuids, newOwnerLogin) => {
    if (!Array.isArray(uuids) || uuids.length === 0) return;
    if (!newOwnerLogin) return;

    setLoading(true);
    try {
        await api.post('/admin/devices/transfer-batch', {
            uuids,
            newOwnerLogin
        });
        toastr.success(' ', `Передано устройств: ${uuids.length} → ${newOwnerLogin}`);
        await handleManualRefresh();
    } catch (err) {
        const msg = err.response?.data?.message || 'Ошибка при пакетной передаче.';
        toastr.warning(' ', msg);
    } finally {
        setLoading(false);
    }
}, [handleManualRefresh]);
// ⬆️ КОНЕЦ ВСТАВКИ

const handleTransferAllMarkedToOtstuki = useCallback(async () => {
    setConfirmModal({
        isOpen: true,
        message: 'Перенести ВСЕ устройства из вкладки "На удаление" пользователю Otstuki прямо сейчас?',
        danger: false,
        onConfirm: async () => {
            setConfirmModal(p => ({ ...p, isOpen: false }));
            setLoading(true);
            try {
                const res = await api.post('/admin/devices/transfer-marked-now');
                toastr.success(' ', res.data?.message || 'Перенос выполнен');
                await handleManualRefresh();
            } catch (err) {
                toastr.warning(' ', err.response?.data?.message || 'Ошибка при переносе');
            } finally {
                setLoading(false);
            }
        }
    });
}, [handleManualRefresh]);

const handleMarkForDeletion = async (device) => {
    try {
        await api.markForDeletion(device.uuid);
        setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
    } catch (err) {
        console.error("Ошибка при пометке на удаление", err);
        toastr.warning(' ', 'Ошибка при пометке на удаление');
    }
};


    const handleUnmarkForDeletion = (device) => {
        setConfirmModal({
            isOpen: true,
            message: `Снять пометку на удаление с устройства ${device.uuid}?`,
            onConfirm: async () => {
                setConfirmModal(p => ({ ...p, isOpen: false }));
                try {
                    await api.unmarkForDeletion(device.uuid);
                    setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
                } catch (err) {
                    toastr.warning(' ', 'Ошибка при снятии пометки');
                }
            }
        });
    };

const handleDeletePermanently = async (device) => {
    try {
        await api.deletePermanently(device.uuid);
        setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
        toastr.success(' ', `Устройство ${device.uuid} полностью удалено`);
    } catch (err) { 
        console.error("Ошибка при полном удалении", err);
        toastr.warning(' ', 'Ошибка при полном удалении');
    }
};

    const handleSelfDestruct = async (device) => {
  if (!ws || ws.current?.readyState !== WebSocket.OPEN) {
    toastr.warning(' ', 'Ошибка: WebSocket соединение не установлено.');
    return;
  }

  try {
    ws.current.send(JSON.stringify({
      action: 'selfDestruct',
      uuid: device.uuid
    }));
    toastr.success(' ', `Команда самоуничтожения отправлена на устройство ${device.uuid}.`);
    setDevices(prevDevices => prevDevices.filter(d => d.uuid !== device.uuid));
  } catch (err) {
    console.error("Ошибка при отправке команды самоуничтожения:", err);
    toastr.warning(' ', 'Произошла ошибка при отправке команды.');
  }
};
    
    const handleSaveNote = async (uuid, note) => {
        try {
            await api.post(`/devices/${uuid}/note`, { note });
        } catch (error) {
            console.error('Не удалось сохранить заметку:', error);
            toastr.warning(' ', 'Ошибка при сохранении заметки. ' + (error.response?.data || ''));
        }
    };

    const handleSaveManualPhone = async (uuid, phone) => {
        try {
            await api.post(`/devices/${uuid}/manual-phone`, { phone });
        } catch (error) {
            console.error('Не удалось сохранить номер:', error);
            toastr.warning(' ', 'Ошибка при сохранении номера. ' + (error.response?.data || ''));
        }
    };

    const handleSendBroadcastUssd = async (requestCode, simIndex) => {
        try {
            const response = await api.broadcastUssd(requestCode, simIndex);
            toastr.info(' ', response.data.message);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Произошла ошибка при отправке команды.';
            toastr.warning(' ', `Ошибка: ${errorMessage}`);
        }
    };

    const handleTabClick = (tabValue) => {
        setActiveTab(tabValue);
        setIsMenuOpen(false);
        setOrderUuids([]);
        if (tabValue !== 'devices') {
            setViewMode('all');
        }
    };
    const handleAllCheckInstallClick = () => {
        setIsCheckMethodModalOpen(true);
    };

    const performBatchOperation = async (mode) => {
        setIsCheckMethodModalOpen(false);
        
        const actionName = mode === 'wake' ? 'Массовое пробуждение (Wake Up)' : 'Тихая проверка (Silent)';
        
        const confirmed = await new Promise((resolve) => {
            setConfirmModal({
                isOpen: true,
                message: `Запустить: ${actionName}? Это затронет ВСЕ активные устройства.`,
                onConfirm: () => { setConfirmModal(p => ({ ...p, isOpen: false })); resolve(true); },
                onCancel: () => { setConfirmModal(p => ({ ...p, isOpen: false })); resolve(false); }
            });
        });
        if (!confirmed) return;
        
        try {
            toastr.info(' ', `Запуск: ${actionName}...`);
            await api.post('/admin/devices/check-install-batch', { mode }); 
        } catch (error) {
            console.error(error);
            toastr.error(' ', 'Ошибка запуска процесса');
        }
    };
    
const sortedDevices = useMemo(() => {
  const map = new Map(devices.map(d => [d.uuid, d]));
  const byOrder = orderUuids.map(u => map.get(u)).filter(Boolean);

  if (byOrder.length < devices.length) {
    devices.forEach(d => {
      if (!orderUuids.includes(d.uuid)) byOrder.push(d);
    });
  }

  // НИЧЕГО не фильтруем по online/offline,
  // порядок уже заложен в orderUuids через rebuildOrder
  return byOrder;
}, [devices, orderUuids, refreshTick]);



    const renderMainContent = () => {
        const content = (
            <>
                <div className="menu-container">
                    <button className="menu-toggle-button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        Меню ≡
                    </button>
                    <nav className={`side-menu ${isMenuOpen ? 'open' : ''}`}>
                        {TABS.map(tab => (
                            <button
                                key={tab.value}
                                onClick={() => handleTabClick(tab.value)}
                                className={`side-menu-button ${activeTab === tab.value ? 'active' : ''}`}
                            >
                                {tab.label}
                                {tab.value === 'privateChat' && chatUnread > 0 && (
                                    <span className="menu-badge">{chatUnread > 99 ? '99+' : chatUnread}</span>
                                )}
                            </button>
                        ))}
                    </nav>
                </div>
                <div className="main-content">
                    {currentUser && user?.role !== 'admin' && (
                        <SubscriptionTimer expiresAt={currentUser.subscriptionExpiresAt} />
                    )}

                    <main>
                        {(activeTab === 'devices' || activeTab === 'banned' || activeTab === 'inWork' || activeTab === 'markedForDeletion' || activeTab === 'deletedApk' || activeTab === 'specialPermissions') && (
                            <DeviceList
                            viewMode={viewMode}
                            onChangeViewMode={setViewMode}
                                clockTick={now}
                                devices={sortedDevices}
                                onSelectDevice={handleSelectDevice}
                                onBanDevice={handleBanDevice}
                                onUnbanDevice={handleUnbanDevice}
                                onMarkInWork={handleMarkInWork}
                                onUnmarkInWork={handleUnmarkInWork}
                                isInWorkView={activeTab === 'inWork'}
                                onSaveNote={handleSaveNote}
                                isAdmin={user?.role === 'admin'}
                                canTransferDevices={!!user?.canTransferDevices}
                                onTransferDevice={handleTransferDevice}
                                sortBy={sortBy} 
                                onSortChange={() => {                
                                  setSortBy(prev => prev === 'online' ? 'offline' : 'online');
                                  rebuildOrder();                     
                               }}
                                onRefresh={handleManualRefresh}
                                isPageLocked={isPageLocked}
                                onTogglePageLock={async () => {
                                  if (isPageLocked) {
                                    // Снимаем замок — очищаем снимок, перезагружаем страницу
                                    setIsPageLocked(false);
                                    setLockedSnapshot([]);
                                  } else {
                                    // Включаем замок — грузим все устройства одним запросом
                                    try {
                                      const tabParam = viewMode === 'newToday' ? 'newToday' : activeTab;
                                      const fetchLimit = totalCount > 0 ? totalCount : 5000;
                                      const resp = await api.get('/devices', {
                                        params: { tab: tabParam, page: 1, limit: fetchLimit }
                                      });
                                      const all = resp.data.devices || [];
                                      const PAGE_SIZE = 50;
                                      const pages = Math.max(1, Math.ceil(all.length / PAGE_SIZE));
                                      setLockedSnapshot(all);
                                      setTotalPages(pages);
                                      setTotalCount(all.length);
                                      setCurrentPage(1);
                                      setDevices(all.slice(0, PAGE_SIZE));
                                      setOrderUuids(all.slice(0, PAGE_SIZE).map(d => d.uuid));
                                    } catch (e) {
                                      console.error('Ошибка загрузки снимка:', e);
                                    }
                                    setIsPageLocked(true);
                                  }
                                }}
                                dateSortOrder={dateSortOrder}
                                onToggleDateSort={async () => {
                                  const PAGE_SIZE = 50;
                                  if (dateSortOrder === null) {
                                    // Выкл → newest: делаем снимок всех устройств и сортируем по createdAt desc
                                    try {
                                      const tabParam = viewMode === 'newToday' ? 'newToday' : activeTab;
                                      const fetchLimit = totalCount > 0 ? totalCount : 5000;
                                      const resp = await api.get('/devices', {
                                        params: { tab: tabParam, page: 1, limit: fetchLimit }
                                      });
                                      const all = resp.data.devices || [];
                                      const sorted = [...all].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                                      const pages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
                                      setDateSortSnapshot(sorted);
                                      setTotalPages(pages);
                                      setTotalCount(sorted.length);
                                      setCurrentPage(1);
                                      setDevices(sorted.slice(0, PAGE_SIZE));
                                      setOrderUuids(sorted.slice(0, PAGE_SIZE).map(d => d.uuid));
                                    } catch (e) {
                                      console.error('Ошибка загрузки снимка по дате:', e);
                                    }
                                    setDateSortOrder('newest');
                                  } else if (dateSortOrder === 'newest') {
                                    // newest → oldest: реверсируем снимок без нового запроса
                                    const reversed = [...dateSortSnapshot].reverse();
                                    setDateSortSnapshot(reversed);
                                    setCurrentPage(1);
                                    setDevices(reversed.slice(0, PAGE_SIZE));
                                    setOrderUuids(reversed.slice(0, PAGE_SIZE).map(d => d.uuid));
                                    setDateSortOrder('oldest');
                                  } else {
                                    // oldest → выкл: сбрасываем снимок, страница перезагрузится сама
                                    setDateSortOrder(null);
                                    setDateSortSnapshot([]);
                                  }
                                }}
                                onMarkForDeletion={handleMarkForDeletion}
                                onUnmarkForDeletion={handleUnmarkForDeletion}
                                onDeletePermanently={handleDeletePermanently}
                                onSelfDestruct={handleSelfDestruct}
                                isBannedView={activeTab === 'banned'}
                                isMarkedForDeletionView={activeTab === 'markedForDeletion'}
                                onBulkDeleteSelected={handleBulkDeleteSelected}
                                onBulkTransferSelected={handleBulkTransferSelected}
                                onTransferAllMarkedToOtstuki={user?.role === 'admin' && activeTab === 'markedForDeletion' ? handleTransferAllMarkedToOtstuki : undefined}
                                onCheckInstall={handleCheckInstall}
                                apkCheckState={apkCheckState}
                                stats={stats}
                                loading={loading}
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalCount={totalCount}
                                onSetPage={setCurrentPage}
                                isGlobalSearch={isGlobalSearch}
                                onUuidSearchExact={handleUuidSearchExact}
                                onNoteSearchExact={handleNoteSearchExact}
                                onPhoneSearchExact={handlePhoneSearchExact}
                                onAppSearchExact={handleAppSearchExact}
                                onAppNameSearchExact={handleAppNameSearchExact}
                                onCarrierSearchExact={handleCarrierSearchExact}
                                onClearSearch={handleClearSearch}
                                primaryFilterType={primarySnapshot ? primarySnapshot.type : null}
                                primaryFilterCount={primarySnapshot ? primarySnapshot.results.length : 0}
                                searchInputReset={searchInputReset}
                                isDeletedApkView={activeTab === 'deletedApk'}
                                isSpecialPermissionsView={activeTab === 'specialPermissions'}
                                activeTab={activeTab}
                                onTabChange={handleTabClick}
                                onSaveManualPhone={handleSaveManualPhone}
                            />
                        )}
                        {activeTab === 'users' && user?.role === 'admin' && (
                            <UserManagement />
                        )}
                        {activeTab === 'notifications' && (
                            <NotificationSettings />
                        )}
                        {activeTab === 'statistics' && (
    <StatisticsTab 
        token={localStorage.getItem('token')} // или token из стейта
        user={user} 
        stats={stats} // <--- ВАЖНО передать статистику
    />
)}
                        {activeTab === 'privateChat' && (
                           <PrivateChat onUnreadChange={setChatUnread} />
                        )}
                    </main>
                </div>
            </>
        );

        if (isMobile && selectedDevice) {
            return (
                <DeviceDetails
                    device={selectedDevice}
                    onClose={handleCloseDetails}
                    ws={ws}
                    isMobile={true}
                    onSaveNote={handleSaveNote}
                    onSaveManualPhone={handleSaveManualPhone}
                />
            );
        }
        return content;
    };

    return (
        <>
        <div>
            <header className="app-header">
                <h1 className="fantasy-hub-title">Fantasy Hub</h1>
                <div className="header-actions">
                    {user?.role === 'admin' && (
                        <>
                         <button
                            onClick={handleAllCheckInstallClick}
                            className="logout-button"
                            style={{ marginRight: '10px', backgroundColor: '#4a90e2' }} 
                         >
                             ALL Chek
                         </button>

                         <button
                            onClick={() => setBroadcastUssdModalOpen(true)}
                            className="logout-button"
                         >
                             Мас. USSD
                         </button>
                        </>
                    )}
                    <button onClick={logout} className="logout-button">Выйти</button>
                </div>
            </header>

            {renderMainContent()}

            {!isMobile && selectedDevice && (
                <DeviceDetails
                    device={selectedDevice}
                    onClose={handleCloseDetails}
                    ws={ws}
                    isMobile={false}
                    onSaveNote={handleSaveNote}
                    onSaveManualPhone={handleSaveManualPhone}
                />
            )}
            
            <BroadcastUssdModal
                isOpen={isBroadcastUssdModalOpen}
                onClose={() => setBroadcastUssdModalOpen(false)}
                onSend={handleSendBroadcastUssd}
            />
            {isCheckMethodModalOpen && (
                <div className="modal-backdrop" onClick={() => setIsCheckMethodModalOpen(false)}>
                    <div className="modal-content" style={{ maxWidth: '400px', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                        <h3 style={{ marginTop: 0, color: '#333' }}>Выберите режим проверки</h3>
                        <p style={{ color: '#666', marginBottom: '20px' }}>
                            Что необходимо сделать со всеми активными устройствами?
                        </p>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <button 
                                onClick={() => performBatchOperation('silent')}
                                style={{ 
                                    padding: '12px', 
                                    backgroundColor: '#4a90e2', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '5px', 
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                🕵️ Тихая проверка (Silent Check)
                                <div style={{ fontSize: '12px', opacity: 0.8 }}>Проверить наличие App без запуска</div>
                            </button>

                            <button 
                                onClick={() => performBatchOperation('wake')}
                                style={{ 
                                    padding: '12px', 
                                    backgroundColor: '#e67e22', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '5px', 
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                🔔 Массовое пробуждение (Wake Up)
                                <div style={{ fontSize: '12px', opacity: 0.8 }}>Отправить wake_ws (High Priority)</div>
                            </button>
                        </div>

                        <button 
                            onClick={() => setIsCheckMethodModalOpen(false)}
                            style={{ 
                                marginTop: '20px', 
                                padding: '8px 16px', 
                                backgroundColor: '#ccc', 
                                border: 'none', 
                                borderRadius: '4px',
                                cursor: 'pointer' 
                            }}
                        >
                            Отмена
                        </button>
                    </div>
                </div>
            )}
        </div>

        <ConfirmModal
            isOpen={confirmModal.isOpen}
            message={confirmModal.message}
            danger={confirmModal.danger}
            onConfirm={confirmModal.onConfirm}
            onCancel={() => setConfirmModal(p => ({ ...p, isOpen: false }))}
        />
        <InputModal
            isOpen={inputModal.isOpen}
            title={inputModal.title}
            fields={inputModal.fields}
            onSubmit={inputModal.onSubmit}
            onCancel={() => setInputModal(p => ({ ...p, isOpen: false }))}
        />
        </>
    );
}

export default Dashboard;
